import Tree from "../../../../structure/tree";
import Rule from "../../rule";

const EmptyRules = { id: "EmptyRules", rules: new Tree(new Rule()) };

export default EmptyRules;
